<template>
	<div class="bj_show_a row" style="display:grid; margin-top: -20px;">
		<div class="row-fluid container-fluid">
			<div>
				<el-carousel indicator-position="outside">
					<el-carousel-item v-for="item in models.detailedjson" :key="item">
						<img :src=item.value_b style="width: 100%; height: 100%;" />
					</el-carousel-item>
				</el-carousel>
			</div>
			<!--最新活动-->
			<div class="span12 text-left">
				<div class="jumbotron" style="padding-top: 20px;padding-bottom: 20px; background: #d3d8de;">
					<div class="container" style="padding-bottom: 10px;">
						<div>
							
							<div class="col-10">
								<div>
									<h4>{{models.title}}</h4>
								</div>
								<div>开放时间（{{models.bin_1}}）</div>
							</div>

						</div>
					</div>
					<div class="tt_10" style="padding-top:6px">详细地址：<span>{{models.bin_2}}</span></div>
					<div class="tt_10" style="padding-top:6px">联系电话：<span>{{models.bin_3}}</span></div>
				</div>

				<div v-if="models.int_1==1">
					 <video  id="myPlayer" style="width: 100%;" :poster=models.text_3 controls playsInline webkit-playsinline    x5-playsinline=""  x5-video-player-fullscreen="true"  x-webkit-airplay="allow"  x5-video-orientation="portraint">
					                            <source :src="models.text_2"  />
					                        </video>
											
											
				

				</div>

				<div style="margin-top: 20px;">
					<h4>展馆介绍</h4>
					<div class="row">
						<div class="col-12" style="text-indent:2em; font-size: 15px; line-height: 35px;"
							v-html="models.detailed_t">
						</div>

					</div>
					<div class="tt_10 jumbotron" style="padding-top:30px;line-height: 25px; margin-top: 20px;">
						交通方面：<span>{{models.text_1}}</span></div>
				</div>

				<div class="col-12" style="height: 3px;"></div>
				<div class="tt_10 tt_x_10" style="margin-top: 10px; margin-bottom: 20px;">
					<h4>展品介绍</h4>
				</div>
			</div>
			<div class="row">
				<div style="margin-top: 0px;" class="col-6" v-for="(item, index) in List_4" :key="index"
					@click="$router.push({ path: 'show_voice', query: { id: item.id } })">
					<div class="col-12 jumbotron"
						style="padding-top:0px; padding-bottom:10px; padding-left: 0px;  padding-right: 0px;">
						<div style="padding-right: 0px">
							<div style="text-align: center;">
								<img style="width: 100%;" :src="item.imgages_b" v-if="item.imgages_b" title="暂无图片" />
								<div class="imgss" v-else>暂&nbsp;无<br />图&nbsp;片</div>
							</div>
						</div>
						<div>
							<h5 class="h5_t_5 info-content" style="margin-left: 5px;">
								{{ item.title }}
							</h5>
						</div>
					</div>
				</div>
			</div>
			<div style="height: 30px;"></div>
		</div>


		<div class="edit" v-show="show">
			<div class="tt_10 tt_x_10">
				<h4 class="text-left">个人资料</h4>
			</div>
			<div class="row">
				<div class="col-12">

					<div class="input-group">
						<span class="input-group-addon">联系姓名</span>
						<input type="text" class="form-control"
							style="border: 1px solid #ccc !important;padding-left: 12px !important;"
							placeholder="填写求助者的真实姓名">
					</div>
					<br>
					<div class="input-group">
						<span class="input-group-addon">联系电话</span>
						<input type="text" class="form-control"
							style="border: 1px solid #ccc !important;padding-left: 12px !important;"
							placeholder="填写求助者的联系电话">
					</div>

					<div class="input-group">
						<textarea rows="2" class="form-control" placeholder="详细描述"></textarea>
					</div>
					<br>
					<div class="col-12">
						<button class='submit_btn' style="margin-top:0px;">提交资料</button>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>


<script>
	export default {
		data() {
			return {
				show: false,
				models: {},
				List_4: [],
				ruleForm: {
					username: "", //用户姓名
					telephone: "", //用户手机
					people: "", //用户地址
					describe: "", //描述
				},
			}
		},
		methods: {
			binWin(v) {
				if (v == 0) {
					this.show = false;
					return
				}
				console.log("res.data.data.models");
				this.show = true;
			},
			binAdd() {

			},
			sel(id) {
				this.$api.getAPI("data/page/" + id + "?type_id=20201103&state=1", {}).then(
					res => {
						console.log(res.data.data.models);
						this.models = res.data.data.models;
						this.getList_4(id)
					})
			},
			//加载服务推荐
			getList_4(id) {
				this.$api.getAPI("data/info/?type_id=20201109&state=1&key_id=" + id).then((res) => {
					var d = res.data.data;
					this.List_4 = d.data[0].models;
					console.log(d.data[0].models);
				});
			},

		},
		mounted() {
			var id = this.$route.query.id;
			this.sel(id);
		}
	}
</script>

<style scoped>
	.el-carousel>>>.el-carousel__container {
		height: 200px;
	}

	.bj_show_a {
		/* //background: #a2acb8; */
		height: 350px;
		/* background: linear-gradient(to bottom right, #a2acb8, #ffffff); */
		background: linear-gradient(#a2acb8, #ffffff);
	}

	.jumbotron_c {
		background: #f3f4f8;
	}

	.label-primary {
		color: #3480fa;
		background-color: #dcdfe6;
	}

	.label_50 {
		border-radius: 50px/50px;
	}

	.label-primary-j1 {
		color: #fff;
		background-color: #91acbe;
		border-radius: 5px 0px 5px 0px;
	}
	.bg_voicea {
		background: url("https://img.hsnms.com/20211201/1638365595.jpg") no-repeat center;
		background-size: 100%;
	}

	.info-content {
		width: 100%;
		/*根据自己项目进行定义宽度*/
		overflow: hidden;
		/*设置超出的部分进行影藏*/
		text-overflow: ellipsis;
		/*设置超出部分使用省略号*/
		white-space: nowrap;
		/*设置为单行*/
	}
</style>



// WEBPACK FOOTER //
// src/components/views/web/bwg/show_special.vue